












import Vue from 'vue';

import AppBar from './components/ui/app-bar/index.vue';
import NavigationDrawer from './components/ui/navigation-drawer/index.vue';

export default Vue.extend({
  name: 'App',

  components: {
    AppBar,
    NavigationDrawer,
  },
});
